__turbopack_context__.v({
  "faqContent": "styles-module__OzcPWa__faqContent",
  "faqTitle": "styles-module__OzcPWa__faqTitle",
  "faqWrapper": "styles-module__OzcPWa__faqWrapper",
});
